"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("@tippyjs/react"));
var _constant = require("../../styles/constant");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
const fit = (0, _styledSystem.variant)({
  prop: '$fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.s'),
      lineHeight: (0, _constant.get)('lineHeights.xs')
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.m'),
      lineHeight: (0, _constant.get)('lineHeights.s')
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.l'),
      lineHeight: (0, _constant.get)('lineHeights.m')
    }
  }
});
const fitPadding = (0, _styledSystem.variant)({
  prop: '$fit',
  variants: {
    small: {
      padding: props => "".concat((0, _constant.get)('space.3')(props), " ").concat((0, _constant.get)('space.7')(props))
    },
    medium: {
      padding: props => "".concat((0, _constant.get)('space.7')(props), " ").concat((0, _constant.get)('space.11')(props))
    },
    large: {
      padding: props => "".concat((0, _constant.get)('space.11')(props), " ").concat((0, _constant.get)('space.15')(props))
    }
  }
});
const StyledTooltip = (0, _styledComponents["default"])(_react["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  --toastify-color-light: ", ";\n  --toastify-color-dark: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  .tippy-arrow {\n    color: ", ";\n  }\n  .tippy-content {\n    ", "\n  }\n  &[data-theme~='light-border'] {\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n  ", "\n"])), (0, _constant.get)('colors.functional.grey.50'), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('colors.functional.grey.50'), (0, _constant.get)('borderRadius.m'), (0, _constant.get)('boxShadows.tooltip.box-shadow-tooltip--inverse'), (0, _constant.get)('colors.functional.grey.900'), fitPadding, (0, _constant.get)('colors.functional.grey.700'), (0, _constant.get)('colors.functional.grey.300'), (0, _constant.get)('colors.functional.grey.50'), (0, _constant.get)('boxShadows.tooltip.box-shadow-tooltip--default'), fit);
const Components = exports.Components = {
  Tooltip: StyledTooltip
};